import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import GridItem from './GridItem.js';
import { Grid as Grid$2 } from './Grid.style.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "columns", "root", "rowGapType", "disableAutoSizing"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Grid = function Grid(_ref) {
  var children = _ref.children,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? 12 : _ref$columns,
    _ref$root = _ref.root,
    root = _ref$root === void 0 ? false : _ref$root,
    _ref$rowGapType = _ref.rowGapType,
    rowGapType = _ref$rowGapType === void 0 ? 'default' : _ref$rowGapType,
    _ref$disableAutoSizin = _ref.disableAutoSizing,
    disableAutoSizing = _ref$disableAutoSizin === void 0 ? false : _ref$disableAutoSizin,
    rest = _objectWithoutProperties(_ref, _excluded);
  var gridSizes = [{
    key: 's',
    counter: 4,
    size: 4
  }, {
    key: 'm',
    counter: columns,
    size: columns
  }, {
    key: 'l',
    counter: columns,
    size: columns
  }];
  var decoratedChildren = React.Children.map(children, function (child) {
    if (!child) {
      return null;
    }
    var columnStart = {};
    var columnEnd = {};
    gridSizes.forEach(function (grid) {
      var size = grid.size,
        key = grid.key,
        counter = grid.counter;
      var _ref2 = (child === null || child === void 0 ? void 0 : child.props) || {},
        columnSpan = _ref2.columnSpan;
      var checkedColumnSpan = columnSpan || size;
      if (key === 's' && checkedColumnSpan > 2) {
        checkedColumnSpan = size;
      }
      if (key === 'm' && checkedColumnSpan < 6 && !disableAutoSizing) {
        checkedColumnSpan = 6;
      }
      var remainder = counter % size;
      var overflows = checkedColumnSpan > size - remainder && remainder > 0;
      columnStart[key] = overflows ? 0 : remainder;
      columnEnd[key] = columnStart[key] + checkedColumnSpan;
      grid.counter += checkedColumnSpan;
      if (overflows) {
        grid.counter += size - remainder;
      }
    });
    if (/*#__PURE__*/React.isValidElement(child) && child.type === GridItem) {
      return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
        columnStart: columnStart,
        columnEnd: columnEnd
      }));
    }
    return child;
  });
  return /*#__PURE__*/jsx(Grid$2, _objectSpread(_objectSpread({
    $root: root,
    $columns: columns,
    $rowGapType: rowGapType
  }, rest), {}, {
    children: decoratedChildren
  }));
};
var Grid$1 = Grid;

export { Grid$1 as default };
//# sourceMappingURL=Grid.js.map
